import { z } from "zod";

export const createCraftSchema = z.object({
    elementType: z.string({ error: "Debes seleccionar una opción" }).min(1, { message: "Debes seleccionar una opción" }),
    formatType: z.string({ error: "Debes seleccionar un formato" }).min(1, { message: "Debes seleccionar un formato" }),
    taxonomy: z.string({ error: "Debes seleccionar una taxonomía" }).min(1, { message: "Debes seleccionar una taxonomía" }),
    legal: z.string(),
    image_rule_id: z.string({ error: "Debes seleccionar una taxonomía" }).min(1, { message: "Debes seleccionar una taxonomía" }),
    template_id: z.string({ error: "Debes seleccionar un template" }).min(1, { message: "Debes seleccionar un template" }),
    file: z.instanceof(File),
});

export const partialCraftSchema = createCraftSchema.partial();

export type CraftSchema = z.infer<typeof createCraftSchema>;
export type PartialCraftSchema = z.infer<typeof partialCraftSchema>;